import { render, staticRenderFns } from "./SocialCentreConfig.vue?vue&type=template&id=4624870e&"
import script from "./SocialCentreConfig.vue?vue&type=script&lang=js&"
export * from "./SocialCentreConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports